class ByfCartSuggestions extends HTMLElement {
  connectedCallback() {
    this.group = this.querySelector('[data-suggestion-group]');
    if (!this.group) return;
    this.cards = [...this.group.children];
    this.drawer = this.closest('theme-drawer');
    this.shuffle = () => {
      const cards = [...this.cards];
      for (let i = cards.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [cards[i], cards[j]] = [cards[j], cards[i]];
      }
      this.group.replaceChildren(...cards.slice(0, 6));
      this.querySelector('[data-suggestion-clone]')?.remove();
      if (!cards.length) { this.hidden = true; return; }
      const clone = this.group.cloneNode(true);
      clone.removeAttribute('data-suggestion-group');
      clone.setAttribute('data-suggestion-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      clone.inert = true;
      this.group.parentElement.append(clone);
    };
    this.shuffle();
    this.drawer?.addEventListener('theme-drawer:open', this.shuffle);
  }
  disconnectedCallback() {
    this.drawer?.removeEventListener('theme-drawer:open', this.shuffle);
  }
}
if (!customElements.get('byf-cart-suggestions')) customElements.define('byf-cart-suggestions', ByfCartSuggestions);
